export const Config = {
  title: 'Rekstrarvörur',
}
